import UI from '../stores/UI'
import HELP from '../stores/Help'

class Video extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      muted: true,
      playing: false,
      ready: false
    }

    this.player = null
  }

  componentDidMount() {
    if (!UI.isTouch) {
      this.refs.vid.addEventListener('loadstart', this.buffer)
      this.refs.vid.addEventListener('waiting', this.buffer)
      this.refs.vid.addEventListener('playing', this.playing)
      this.refs.vid.addEventListener('canplay', this.canPlay)
    }
  }

  componentWillUnmount() {
    this.refs.vid.removeEventListener('loadstart', this.buffer, false)
    this.refs.vid.removeEventListener('waiting', this.buffer, false)
    this.refs.vid.removeEventListener('playing', this.playing, false)
    this.refs.vid.removeEventListener('canplay', this.canPlay, false)
    UI.updateLoading(false, 'video unmount')
  }

  buffer = () => {
    UI.updateLoading(true, 'buffering')
  }

  playing = () => {
    UI.updateLoading(false, 'playing')
  }

  canPlay = () => {
    UI.updateLoading(false, 'can play')
    this.setState({ ready: true })
  }

  handleClick = e => {
    e.stopPropagation()
    // this.mute()
    if (this.state.ready) {
      this.playOrPause()
    } else {
      console.log('video not ready yet')
    }
  }

  playOrPause() {
    if (this.state.playing) {
      this.refs.vid.pause()
      this.setState({ playing: false })
    } else {
      this.refs.vid.play()
      this.setState({ playing: true })
    }
  }

  mute() {
    this.setState((prevState) => {
      return {
        muted: !prevState.muted
      }
    })
  }

  render() {

    const videoSrc = this.props.file.fields.file.url
    const poster = HELP.getMedia(this.props.poster).src
    const isMuted = UI.isTouch ? false : this.state.muted

    return (
      <div className="fs center">
        <div className="rel inlb vimeo" onClick={!UI.isTouch ? this.handleClick : e => false} onMouseEnter={this.props.enterVideo} onMouseLeave={this.props.leaveVideo} onMouseMove={this.props.enterVideo} style={{
          cursor: UI.isLoading ? 'none' : 'pointer'
        }}>
          <div style={{ paddingTop: '56.6%' }} />
          <div className="pabs fs video-wrapper" ref="el" style={{
            backgroundColor: this.state.ready ? `transparent` : `rgba(0,0,0,0.3)`
          }}>
            <video poster={poster} src={videoSrc} className="fs" controls={UI.isTouch} loop={!UI.isTouch} ref="vid" />
          </div>
          {!UI.isTouch ? <div className="pabs fs" /> : null}
          {!this.state.playing && !UI.isTouch ? (
            <div className="txt-c padx2" style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "100%",
              transform: `translateY(100%)`
            }}>Click to play</div>
          ) : null}
        </div>
      </div>
    )
  }
}

export default Video



// WEBPACK FOOTER //
// ./app/javascript/packs/components/Video.js